
// React Components
import { useNavigate } from "react-router-dom";

// Material UI Components
import { Button, Grid, Paper } from '@mui/material';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import Typography from '@mui/material/Typography';

export default function InsightsSearchBox(props){

     const { colSpanVal, workloadName } = props;

    const navigate = useNavigate();

    return(
        
    <Grid item xs={12} md={colSpanVal} sx={{ p: 2 }}>
        <Paper
            elevation={3}
            sx={{ p: 2, border: "1px solid lightgray", height: "100%" }}
        >
            <div style={{ height: "100%" }}>
                <Typography
                    component="div"
                    variant="h6"
                    sx={{ fontSize: 16, paddingBottom: 1 }}
                >
                    Search Your {workloadName} Audit Records
                </Typography>
                <br />
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                    }}
                >
                    <Button
                        size="small"
                        variant="outlined"
                        startIcon={<ManageSearchIcon />}
                        onClick={() => navigate(`/Reports/InsightsSearch/All`)}
                        sx={{ width: { xs: '100%', sm: 'auto' }, whiteSpace: 'normal' }}
                    >
                        Configure and run an Insights Search
                    </Button>
                </div>
            </div>
        </Paper>
    </Grid>
    );
};
